import { useNavigate } from 'react-router-dom';

export default function CaseStudies() {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            💼 Case Studies: How the System Works in Practice
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
            We don't hide results. Here are examples of how implementing strategy and end-to-end analytics affects revenue in real time.
          </p>
          <button
            onClick={() => navigate('/case')}
            className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white font-semibold text-lg rounded-xl transition-all duration-300 shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-folder-open-line text-2xl"></i>
            Explore Completed Projects
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
